const urlRegex = /https?:\/\/[^\s/$.?#].[^\s]*/;
/**
 * Extracts a URL and its surrounding text from a string
 * @param input The input string containing text and a URL
 * @returns Object with the URL and the text without the URL, or null if no URL found
 */
export interface UrlTextExtract {
    url: string;
    urlIndex?: number;
    text: string;
}

export function removeQueryParamFromUrl(url: string, params: Array<string>) {
    const relativeUrlBase = 'http://localhost';
    const isRelative = !/^https?:\/\//i.test(url);

    const urlObj = new URL(url, isRelative ? relativeUrlBase : undefined);

    params.forEach(p => urlObj.searchParams.delete(p));

    return isRelative ? urlObj.toString().replace(relativeUrlBase, '') : urlObj.toString();
}

export function extractUrlAndText(input: string): UrlTextExtract | null {
    const match = input.match(urlRegex);
    if (!match) {
        return null;
    }

    const url = match[0];
    const text = input;

    return {
        url,
        urlIndex: match?.index,
        text,
    };
}

export const buildQueryString = obj => new URLSearchParams(obj).toString();

/**
 * Extracts a job ID from a URL that contains /job/details/{id}
 * @param url The URL to extract the job ID from
 * @returns The job ID as a number, or 0 if no job ID was found
 */
export function extractJobId(url: string): number {
    const match = url.match(/\/job\/details\/(\d+)/);
    return Number(match?.[1]) || 0;
}

export function addQueryParamsToUrl(url: string, params: Record<string, string>): string {
    if (!params) {
        return url;
    }
    const urlObj = new URL(url);
    Object.entries(params).forEach(([key, value]) => {
        urlObj.searchParams.set(key, value); // Using set instead of append to overwrite existing values
    });
    return urlObj.toString();
}
